import { render, staticRenderFns } from "./XModal.vue?vue&type=template&id=6d1f5820&"
import script from "./XModal.vue?vue&type=script&lang=ts&"
export * from "./XModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports